export default __webpack_public_path__ + "static/media/text.5affe879.svg";